import { useQuery } from '@tanstack/react-query';
import { pmsFrom } from '@/integrations/pms';

/**
 * Returns the industry slug used for service area URL prefixes.
 * e.g. "hvac" → /hvac/:region/:location
 */
export function useIndustrySlug() {
  const { data: industrySlug = '' } = useQuery({
    queryKey: ['industry-slug'],
    queryFn: async () => {
      const { data } = await pmsFrom('business_settings')
        .select('industry')
        .limit(1)
        .maybeSingle();
      return (data?.industry || 'services').toLowerCase().replace(/\s+/g, '-');
    },
    staleTime: Infinity,
  });
  return industrySlug;
}

/**
 * Build service area paths using the industry prefix.
 */
export function useServiceAreaPaths() {
  const industry = useIndustrySlug();
  return {
    industry,
    areasIndex: `/${industry}`,
    regionPath: (regionSlug: string) => `/${industry}/${regionSlug}`,
    locationPath: (regionSlug: string, locationSlug: string) => `/${industry}/${regionSlug}/${locationSlug}`,
    /** Fallback for locations without a region */
    locationDirectPath: (locationSlug: string) => `/${industry}/${locationSlug}`,
  };
}
